<template>
  <v-container class="bottom">
    <v-layout row>
      <v-flex class="containerBanner" md10 lg10 xs12 sm11 xl10>
        <img :src="img1" style="width:100%;" />
      </v-flex>
    </v-layout>
    <v-layout row>
      <v-flex offset-xs0 offset-md1 offset-lg0 offset-sm0 offset-xl0 md9 lg10 xs12 sm11 xl10>
        <v-flex v-if="vacio" class="containerBanner" md12 lg12 xs12 sm12>
          <img :src="nube" style="width:25%;" />
        </v-flex>
        <v-flex v-if="vacio" md12 lg12 xs12 sm12>
          <h4>No existen proyectos para el año {{this.$route.params.id}}</h4>
          <h4>Crea un nuevo proyecto</h4>
        </v-flex>
        <v-flex class="containerStyle2" md12 lg12 xs12 sm12 v-if="!vacio">
          <v-layout>
            <v-flex md10 lg10 xs10 sm10>
              <label class="left" for="sel1">Proyectos</label>
              <select class="form-control" id="5" @change="cargarProyecto()" v-model="proyecto">
                <option selected disabled>-Selecciona una opción-</option>
                <option
                  v-for="(proyecto,index) in proyectos"
                  :key="index"
                  :value="proyecto"
                >{{proyecto.nombreProyecto}}</option>
              </select>
            </v-flex>
            <v-flex md2 lg2 xs2 sm2>
              <v-btn id="boton"
                color="#394049"
                v-if="!vacio && this.$session.getAll().userType == 'dge'"
                @click="descargarProyectos()"
              ><v-icon dark>cloud_download</v-icon></v-btn>
            </v-flex>
          </v-layout>

          <v-layout>
            <v-flex md12 lg12 xs12 sm12 xl12>
              <table class="table table-striped header-fixed">
                <thead>
                  <tr>
                    <th
                      style="text-align: left"
                      class="col-md-2 col-xs-2 col-lg-2 col-sm-2 th-border"
                    >Nombre de proyecto</th>
                    <th
                      style="text-align: left"
                      class="col-md-10 col-xs-10 col-lg-10 col-sm-10 th-border"
                    >{{proyecto.nombreProyecto}}</th>
                  </tr>
                  <tr>
                    <th
                      style="text-align: left"
                      class="col-md-2 col-xs-2 col-lg-2 col-sm-2 th-border"
                    >Año</th>
                    <th
                      style="text-align: left"
                      class="col-md-10 col-xs-10 col-lg-10 col-sm-10 th-border"
                    >{{proyecto.ano}}</th>
                  </tr>
                  <tr>
                    <th
                      style="text-align: left"
                      class="col-md-2 col-xs-2 col-lg-2 col-sm-2 th-border"
                    >Objetivo Estratégico</th>
                    <th
                      style="text-align: left"
                      class="col-md-10 col-xs-10 col-lg-10 col-sm-10 th-border"
                    >{{proyecto.objetivoEstrategico}}</th>
                  </tr>

                  <tr>
                    <th
                      style="text-align: center"
                      :class="header.border"
                      v-for="(header,index) in headers"
                      :key="index"
                    >{{header.text}}</th>
                  </tr>
                </thead>
                <tbody>
                  <tr v-for="(item,index) in hitos" :key="index">
                    <td style="text-align:left " :class="headers[0].size">{{item.nombreHito}}</td>
                    <td style="text-align:center " :class="headers[1].size">{{item.actividades}}</td>
                    <!-- esto formatea fechas-->

                    <td style="text-align:center " :class="headers[2].size">{{item.fechaInicio}}</td>
                    <td style="text-align:center " :class="headers[3].size">{{item.fechaTermino}}</td>
                    <td
                      style="text-align:center "
                      :class="headers[4].size"
                    >{{item.medioVerificacion}}</td>
                    <td style="text-align:center " :class="headers[5].size">{{item.estadoAvance}}</td>
                    <td style="text-align:center " :class="headers[6].size">{{item.observaciones}}</td>
                    <td style="text-align:center " :class="headers[7].size">{{item.evaluacion}}</td>
                    <td :class="headers[8].size">
                      <v-icon
                        v-if="permiso && ano == 2018"
                        small
                        class="mr-2"
                        @click="openEditObservaciones(item,index)"
                      >edit</v-icon>
                      <v-icon
                        v-if="ano == 2019"
                        small
                        class="mr-2"
                        @click="openEditObservaciones(item,index)"
                      >edit</v-icon>
                    </td>
                  </tr>
                </tbody>
              </table>
            </v-flex>
          </v-layout>
        </v-flex>
      </v-flex>
    </v-layout>
    <v-layout>
      <v-btn v-if="permiso" color="#394049" @click="openEditProyecto()">Editar proyecto</v-btn>
      <v-btn color="#394049" @click="opencreateProyecto()">Agregar proyecto</v-btn>
      <v-btn color="#394049" v-if="!vacio" @click="opencreateHito">Agregar hito</v-btn>
      <v-btn
        color="#394049"
        v-if="!vacio"
        :to="{name:'documentos',params: { id: this.$route.params.id }}"
      >Ver evidencias</v-btn>
      <v-btn color="#394049" v-if="!vacio" @click="descargarEvaluacion()">Descargar Evaluación</v-btn>
      <v-btn color="#EB7704" v-if=" !vacio" @click="preguntas = !preguntas">Evaluación Anual</v-btn>
    </v-layout>

    <v-layout>
      <v-dialog v-model="edit" width="600px">
        <template v-slot:activator="{ on }"></template>
        <v-card>
          <v-card-title>
            <span class="headline" v-if="!create">Editar hito</span>
            <span class="headline" v-if="create">Crear hito</span>
          </v-card-title>
          <v-flex offset-md1 offset-lg1 offset-xs1 offset-sm1 md10 lg10 xs10 sm10>
            <v-layout row>
              <v-flex md12 lg12 xs12 sm12>
                <label for="usr">Proyecto asociado</label>
                <input
                  :disabled="true"
                  v-model="proyecto.nombreProyecto"
                  type="text"
                  class="form-control"
                  id="usr"
                />
              </v-flex>
            </v-layout>
            <v-layout row>
              <v-flex md12 lg12 xs12 sm12>
                <label for="usr">Hito</label>
                <input
                  :disabled="!permiso"
                  v-model="hito.nombreHito"
                  type="text"
                  class="form-control"
                  id="usr"
                />
              </v-flex>
            </v-layout>
            <v-layout row>
              <v-flex md12 lg12 xs12 sm12>
                <label for="usr">Actividades</label>
                <textarea
                  :disabled="!permiso"
                  v-model="hito.actividades"
                  type="text"
                  class="form-control"
                  id="usr"
                />
              </v-flex>
            </v-layout>
            <v-layout row>
              <v-flex md16 lg16 xs6 sm6>
                <label for="usr">Fecha de inicio</label>
                <input
                  :disabled="!permiso"
                  v-model="hito.fechaInicio"
                  type="text"
                  class="form-control"
                  id="usr"
                />
              </v-flex>
              <v-flex md6 lg6 xs6 sm6>
                <label for="usr">Fecha de termino</label>
                <input
                  :disabled="!permiso"
                  v-model="hito.fechaTermino"
                  type="text"
                  class="form-control"
                  id="usr"
                />
              </v-flex>
            </v-layout>

            <v-layout row>
              <v-flex md12 lg12 xs12 sm12>
                <label for="usr">Medio de verificación</label>
                <input
                  :disabled="!permiso"
                  v-model="hito.medioVerificacion"
                  type="text"
                  class="form-control"
                  id="usr"
                />
              </v-flex>
            </v-layout>

            <v-layout row>
              <v-flex md12 lg12 xs12 sm12>
                <label class="left" for="sel1">Estado de avance</label>
                <select class="form-control" id="5" v-model="hito.estadoAvance">
                  <option selected disabled>-Selecciona una opción-</option>
                  <option value="No iniciado">No iniciado</option>
                  <option value="En desarrollo">En desarrollo</option>
                  <option value="Finalizado">Finalizado</option>
                </select>
              </v-flex>
            </v-layout>

            <v-layout row>
              <v-flex md12 lg12 xs12 sm12>
                <label for="usr">Observaciones</label>
                <textarea v-model="hito.observaciones" type="text" class="form-control" id="usr" />
              </v-flex>
            </v-layout>

            <v-layout row>
              <v-flex md12 lg12 xs12 sm12>
                <label class="left" for="sel1">Evaluación</label>
                <select class="form-control" id="5" v-model="hito.evaluacion">
                  <option selected disabled>-Selecciona una opción-</option>
                  <option
                    value="Los resultados esperados se cumplen en forma insuficiente"
                  >Los resultados esperados se cumplen en forma insuficiente</option>
                  <option
                    value="Los resultados esperados cumplen en forma satisfactoria"
                  >Los resultados esperados cumplen en forma satisfactoria</option>
                  <option
                    value="Los resultados superan satisfactoriamente lo esperado"
                  >Los resultados superan satisfactoriamente lo esperado</option>
                </select>
              </v-flex>
            </v-layout>
          </v-flex>

          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn color="#ec6a12" flat="flat" @click="edit = false">Cerrar</v-btn>
            <v-btn color="#394049" flat="flat" v-if="!create" @click="editHito()">Guardar</v-btn>
            <v-btn color="#394049" flat="flat" v-if="create" @click="createHito()">Crear</v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>
    </v-layout>

    <v-layout>
      <v-dialog v-model="project" width="600px">
        <template v-slot:activator="{ on }"></template>
        <v-card>
          <v-card-title>
            <span class="headline">Crear Proyecto</span>
          </v-card-title>
          <v-flex offset-md1 offset-lg1 offset-xs1 offset-sm1 md10 lg10 xs10 sm10>
            <v-layout row>
              <v-flex md12 lg12 xs12 sm12>
                <label for="usr">Nombre de Proyecto</label>
                <input
                  v-model="proyectoNuevo.nombreProyecto"
                  type="text"
                  class="form-control"
                  id="usr"
                />
              </v-flex>
            </v-layout>

            <v-layout row>
              <v-flex md12 lg12 xs12 sm12>
                <label for="usr">Año de Proyecto</label>
                <input
                  :disabled="true"
                  v-model="proyectoNuevo.ano"
                  type="text"
                  class="form-control"
                  id="usr"
                />
              </v-flex>
            </v-layout>
            <v-layout row>
              <v-flex md12 lg12 xs12 sm12>
                <label for="usr">Objetivo Estratégico</label>
                <input
                  v-model="proyectoNuevo.objetivoEstrategico"
                  type="text"
                  class="form-control"
                  id="usr"
                />
              </v-flex>
            </v-layout>
          </v-flex>
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn color="#ec6a12" flat="flat" @click="project = false">Cerrar</v-btn>
            <v-btn color="#394049" flat="flat" @click="createProyecto()">Crear</v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>
    </v-layout>

    <v-layout>
      <v-dialog v-model="projectEdit" width="600px">
        <template v-slot:activator="{ on }"></template>
        <v-card>
          <v-card-title>
            <span class="headline">Editar Proyecto</span>
          </v-card-title>
          <v-flex offset-md1 offset-lg1 offset-xs1 offset-sm1 md10 lg10 xs10 sm10>
            <v-layout row>
              <v-flex md12 lg12 xs12 sm12>
                <label for="usr">Nombre de Proyecto</label>
                <input v-model="proyecto.nombreProyecto" type="text" class="form-control" id="usr" />
              </v-flex>
            </v-layout>

            <v-layout row>
              <v-flex md12 lg12 xs12 sm12>
                <label for="usr">Año de Proyecto</label>
                <input
                  :disabled="true"
                  v-model="proyecto.ano"
                  type="text"
                  class="form-control"
                  id="usr"
                />
              </v-flex>
            </v-layout>
            <v-layout row>
              <v-flex md12 lg12 xs12 sm12>
                <label for="usr">Objetivo Estratégico</label>
                <input
                  v-model="proyecto.objetivoEstrategico"
                  type="text"
                  class="form-control"
                  id="usr"
                />
              </v-flex>
            </v-layout>
          </v-flex>
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn color="rgb(236, 18, 40)" flat="flat" @click="deleteProyecto(proyecto)">Eliminar</v-btn>
            <v-btn color="#ec6a12" flat="flat" @click="projectEdit = false">Cerrar</v-btn>
            <v-btn color="#394049" flat="flat" @click="editProyecto()">Actualizar</v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>
    </v-layout>

    <v-layout>
      <v-dialog v-model="preguntas" width="600px">
        <template v-slot:activator="{ on }"></template>
        <v-card>
          <v-card-title>
            <span class="headline">Evaluación Anual</span>
          </v-card-title>
          <v-flex offset-md1 offset-lg1 offset-xs1 offset-sm1 md10 lg10 xs10 sm10>
            <v-layout row>
              <v-flex md12 lg12 xs12 sm12>
                <label
                  for="usr"
                >¿Cuáles son los principales aportes del proyecto al desarrollo estratégico de su unidad?</label>
                <textarea v-model="proyecto.pregunta1" type="text" class="form-control" id="usr" />
              </v-flex>
            </v-layout>

            <v-layout row>
              <v-flex md12 lg12 xs12 sm12>
                <label
                  for="usr"
                >¿Cuáles son los avances obtenidos respecto al objetivo estratégico asociado al proyecto?</label>
                <textarea v-model="proyecto.pregunta2" type="text" class="form-control" id="usr" />
              </v-flex>
            </v-layout>

            <v-layout row>
              <v-flex md12 lg12 xs12 sm12>
                <label
                  for="usr"
                >¿Qué elementos de su proyecto, considera necesario que se pueda replicar a nivel institucional?</label>
                <textarea v-model="proyecto.pregunta3" type="text" class="form-control" id="usr" />
              </v-flex>
            </v-layout>
          </v-flex>
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn color="#ec6a12" flat="flat" @click="preguntas = false">Cerrar</v-btn>
            <v-btn color="#394049" flat="flat" @click="addPreguntas()">Crear</v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>
    </v-layout>
  </v-container>
</template>


<script>
import img1 from "../../assets/BANNER_4.png";
import img3 from "../../assets/nuevaasistenciadca.png";
import nube from "../../assets/nube.png";

export default {
  data() {
    return {
      projectEdit: false,
      ano: "",
      permiso: "",
      preguntas: false,
      vacio: false,
      img3: img3,
      proyecto: [],
      proyectoNuevo: {
        ano: "",
        nombreProyecto: "",
        objetivoEstrategico: ""
      },
      project: false,
      proyectos: "",
      nube: nube,
      hitos: "",
      asistencia: false,
      create: false,
      edit: false,
      index: "",
      tipodimension: "",
      dialog: false,
      hito: {},
      misionPropuesta:
        "Contrary to popular belief, Lorem Ipsum is not simply random text. It has roots in a piece of classical Latin literature from 45 BC, making it over 2000 years old. Richard McClintock, a Latin professor at Hampden-Sydney College in Virginia, looked up one of the more obscure Latin words, consectetur, from a Lorem Ipsum passage, and going through the cites of the word, Contrary to popular belief, Lorem Ipsum is not simply random text. It has roots in a piece of classical Latin literature from 45 BC, making it over 2000 years old. Richard McClintock, a Latin professor at Hampden-Sydney College in Virginia, looked up one of the more obscure Latin words, consectetur, from a Lorem Ipsum passage, and going through the cites of the word",
      headers: [
        {
          text: "Hito",
          value: "name",
          size: "col-md-2 col-lg-2 col-sm-2 col-xs-2",
          border: "col-md-2 col-lg-2 col-sm-2 col-xs-2 th-border"
        },
        {
          text: "Actividad",
          value: "name",
          size: "col-md-2 col-lg-2 col-sm-2 col-xs-2",
          border: "col-md-2 col-lg-2 col-sm-2 col-xs-2 th-border"
        },

        {
          text: "Inicio",
          value: "muy desacuerdo",
          size: "col-md-1 col-lg-1 col-sm-1 col-xs-1",
          border: "col-md-1 col-lg-1 col-sm-1 col-xs-1 th-border"
        },
        {
          text: "Termino",
          value: "muy desacuerdo",
          size: "col-md-1 col-lg-1 col-sm-1 col-xs-1",
          border: "col-md-1 col-lg-1 col-sm-1 col-xs-1 th-border"
        },
        {
          text: "Verificación",
          value: "muy desacuerdo",
          size: "col-md-1 col-lg-1 col-sm-1 col-xs-1",
          border: "col-md-1 col-lg-1 col-sm-1 col-xs-1 th-border"
        },

        {
          text: "Avance",
          value: "muy desacuerdo",
          size: "col-md-1 col-lg-1 col-sm-1 col-xs-1",
          border: "col-md-1 col-lg-1 col-sm-1 col-xs-1 th-border"
        },
        {
          text: "Observaciones",
          value: "muy desacuerdo",
          size: "col-md-2 col-lg-2 col-sm-2 col-xs-2",
          border: "col-md-2 col-lg-2 col-sm-2 col-xs-2 th-border"
        },
        {
          text: "Evaluación",
          value: "muy desacuerdo",
          size: "col-md-1 col-lg-1 col-sm-1 col-xs-1",
          border: "col-md-1 col-lg-1 col-sm-1 col-xs-1 th-border"
        },
        {
          text: "Editar",
          value: "muy desacuerdo",
          size: "col-md-1 col-lg-1 col-sm-1 col-xs-1",
          border: "col-md-1 col-lg-1 col-sm-1 col-xs-1 th-border"
        }
      ],
      typeEstrategico: "1",
      auth: {
        headers: { Authorization: "" + this.$session.get("jwt") }
      },
      img1: img1,
      right: null
    };
  },

  watch: {
    "$route.fullPath": function() {
      //console.log("whatcher a detectado un cambio en user");
      this.initComponent();
    }
  },

  created() {
    //console.log(this.$session.getAll().permiso);

    this.initComponent();
  },
  methods: {
    redirect(index) {
      this.typeEstrategico = index;
    },
    updateOtros(propuesta) {
      this.dialog = false;
    },

    cargarProyecto() {
      this.cargarHitos();
    },

    forceFileDownload(response,tipo) {
      //console.log("Aqui va el header");
      //console.log(response.headers);
      const url = window.URL.createObjectURL(
        new Blob([response.data], { type: response.headers["content-type"] })
      );
      const link = document.createElement("a");
      link.href = url;
      link.setAttribute(
        "download",
        tipo +"-centro-costo-" +
          this.$session.getAll().ccData.ccValor +
          ".xlsx"
      ); //or any other extension
      document.body.appendChild(link);
      link.click();
    },

    descargarEvaluacion() {
      axios
        .get(
          process.env.ROOT_API +
            "/proyecto/exportProyectos?ccValor=" +
            this.$session.getAll().ccData.ccValor,
          {
            responseType: "arraybuffer",
            headers: { Authorization: "" + this.$session.get("jwt") }
          }
        )
        .then(response => {
          this.forceFileDownload(response, "Info general proyectos");

          //console.log(this.hitos);
        })
        .catch(error => {
          console.error(error);
        });
    },

    descargarProyectos() {
      axios
        .get(
          process.env.ROOT_API +
            "/hito/exportHitos?ccValor=" +
            this.$session.getAll().ccData.ccValor,
          {
            responseType: "arraybuffer",
            headers: { Authorization: "" + this.$session.get("jwt") }
          }
        )
        .then(response => {
          this.forceFileDownload(response, "Detalle hitos de proyectos");

          //console.log(this.hitos);
        })
        .catch(error => {
          console.error(error);
        });
    },
    initComponent() {
      this.ano = parseInt(this.$route.params.id);
      this.permiso = this.$session.getAll().permiso;
      axios
        .get(
          process.env.ROOT_API +
            "/proyecto/allProyectos?ano=" +
            this.ano +
            "&ccValor=" +
            this.$session.getAll().ccData.ccValor,
          this.auth
        )
        .then(response => {
          this.proyectos = response.data;
          if (response.data.length == 0) {
            //console.log("ENTRANDO AL VACIOOOOOOOOOOOOOOOOOOOOOOOOOOOOOOO");
            this.vacio = true;
            //console.log("Vacio1: " + this.vacio);
          } else {
            this.vacio = false;
            this.proyecto = this.proyectos[0];
            //console.log(this.proyectos);
            this.cargarHitos();
            //console.log("Vacio2: " + this.vacio);
          }
        })
        .catch(error => {
          console.error(error);
        });
    },

    cargarHitos() {
      axios
        .get(
          process.env.ROOT_API +
            "/hito/allHitosByProyecto?idProyecto=" +
            this.proyecto.id,
          this.auth
        )
        .then(response => {
          this.hitos = response.data;
          //console.log(this.hitos);
        })
        .catch(error => {
          console.error(error);
        });
    },

    dateFormatted(date) {
      var current_datetime = new Date(date);
      var formatted_date =
        current_datetime.getDate() +
        "-" +
        (current_datetime.getMonth() + 1) +
        "-" +
        current_datetime.getFullYear();
      return formatted_date;
    },

    dateFormattedUSA(date) {
      var current_datetime = new Date(date);
      var formatted_date =
        current_datetime.getMonth() +
        1 +
        "-" +
        current_datetime.getDate() +
        "-" +
        current_datetime.getFullYear();
      return formatted_date;
    },

    openEditObservaciones(hito, index) {
      this.create = false;
      this.edit = true;
      this.index = index;
      this.hito = hito;
    },

    openEditProyecto() {
      this.proyectoNuevo.nombreProyecto = this.proyecto.nombreProyecto;
      this.proyectoNuevo.objetivoEstrategico = this.proyecto.objetivoEstrategico;
      this.proyectoNuevo.ano = parseInt(this.$route.params.id);
      this.projectEdit = true;
    },

    deleteProyecto(item) {
      //console.log( item);
      axios
        .delete(
          process.env.ROOT_API + "/proyecto/delete?idProyecto=" + item.id,
          this.auth
        )
        .then(response => {
          //console.log(response.data);
          alert(response.data);
          this.initComponent();
        })
        .catch(error => {
          //console.log(error);
          alert(error);
        });
      this.projectEdit = false;
    },

    opencreateProyecto(hito, index) {
      this.proyectoNuevo.nombreProyecto = "";
      this.proyectoNuevo.objetivoEstrategico = "";
      this.proyectoNuevo.ano = parseInt(this.$route.params.id);
      this.project = true;
    },
    createProyecto() {
      axios
        .post(
          process.env.ROOT_API +
            "/proyecto/createProyecto?ccValor=" +
            this.$session.getAll().ccData.ccValor,
          this.proyectoNuevo,
          this.auth
        )
        .then(response => {
          //console.log(response.data);
          alert("Proyecto creado");
          this.project = false;
          this.vacio = false;
          this.initComponent();
        })
        .catch(error => {
          console.error(error);
          alert(error);
        });
    },

    opencreateHito() {
      this.create = true;
      this.edit = true;
      this.hito = {};
    },

    editHito() {
      axios
        .post(process.env.ROOT_API + "/hito/updateHito", this.hito, this.auth)
        .then(response => {
          //console.log(response.data);
          alert("Hito actualizado");
          this.edit = false;
          this.cargarHitos();
        })
        .catch(error => {
          console.error(error);
          alert(error);
        });
    },

    editProyecto() {
      axios
        .post(
          process.env.ROOT_API + "/proyecto/updateProyecto",
          this.proyecto,
          this.auth
        )
        .then(response => {
          //console.log(response.data);
          alert("Proyecto actualizado");
          this.projectEdit = false;
          this.cargarProyecto();
        })
        .catch(error => {
          console.error(error);
          alert(error);
        });
    },

    createHito() {
      axios
        .post(
          process.env.ROOT_API +
            "/hito/createHito?idProyecto=" +
            this.proyecto.id,
          this.hito,
          this.auth
        )
        .then(response => {
          //console.log(response.data);
          alert("Hito agregado");
          this.edit = false;
          this.cargarHitos();
        })
        .catch(error => {
          console.error(error);
          alert(error);
        });
    },

    addPreguntas() {
      axios
        .post(
          process.env.ROOT_API + "/proyecto/addPreguntas",
          this.proyecto,
          this.auth
        )
        .then(response => {
          //console.log(response.data);
          alert("Evaluación anual completada");
          this.preguntas = false;
          this.cargarProyecto();
        })
        .catch(error => {
          console.error(error);
          alert(error);
        });
    },

    replaceT(texto) {
      var newTexto = texto.replace(/\n/g, "<br />");
      //console.log(newTexto);
      return newTexto;
    }
  }
};
</script>


<style scoped>
.image {
  cursor: pointer;
}
.text-mision {
  color: rgb(255, 255, 255);
  font-size: 11px;
}

.titlep {
  color: #ec6a12;
  font-size: 12px;
}

.table2 {
  height: 100px !important;
}

.v-card-new {
  margin-top: 50px;
  margin-bottom: 3%;
  margin-left: 3%;
  padding-right: 15px;
  padding-left: 15px;
  padding-top: 0.5%;
  background: #394049 !important;
  height: 230px !important;
  overflow-y: auto;
}

.v-card {
  height: 350px;
  overflow-y: auto;
}

.td-color {
  background: #394049;
  height: 100%;
}

.containerBanner {
  width: 100%;
  margin-top: 50px !important;
}

.drawner {
  width: 200px !important;
  height: 300px !important;
  margin-left: 15px !important;
  margin-top: 80px !important;
  text-decoration: none !important;
  background-color: #f1f1f1 !important;
  border-left: 1px solid black !important;
}

.drawner2 {
  width: 100% !important;
  height: 250px !important;

  text-decoration: none !important;
  background-color: #394049 !important;
}

.font {
  color: white !important;
}

.containerStyle2 {
  width: 100% !important;
  margin-top: 10px !important;
}
.video {
  width: 100% !important;
  margin-top: 10px !important;
  height: 400px;
}

.containerStyle1 {
  width: 100%;
  margin-top: 25%;
  margin-bottom: 50px;
}

.pull {
  text-align: justify;
}

.v-list-new {
  height: 100% !important;
}

.v-btn__content {
  font-size: 10px !important;
}

.theme--light.v-btn {
  color: white;
}

.v-btn {
  font-size: 10px;
  border-radius: 50px;
}

.header-fixed {
  width: 100%;
}
.header-fixed > thead,
.header-fixed > tbody,
.header-fixed > thead > tr,
.header-fixed > tbody > tr,
.header-fixed > thead > tr > th,
.header-fixed > tbody > tr > td {
  display: block;
}
.header-fixed > tbody > tr:after,
.header-fixed > thead > tr:after {
  content: " ";
  display: block;
  visibility: hidden;
  clear: both;
}
.header-fixed > tbody {
  overflow-y: auto;
  height: 300px;
  width: 100%;
}

.header-fixed > tbody > tr > td,
.header-fixed > thead > tr > th {
  float: left;
  font-size: 11px;
  border-bottom: 0 !important;
}

.th-border {
  border: #ddd 1px solid !important;
}

.th {
  background-color: aqua !important;
}

/* width */
::-webkit-scrollbar {
  width: 3px;
}

/* Track */
::-webkit-scrollbar-track {
  background: #f1f1f1;
}

/* Handle */
::-webkit-scrollbar-thumb {
  background: #888;
}

/* Handle on hover */
::-webkit-scrollbar-thumb:hover {
  background: #555;
}

.bottom {
  margin-bottom: 50px !important;
}

#boton{
  margin-top: 25px;
}
</style>


// WEBPACK FOOTER //
// src/components/implementacion/Seguimiento.vue